import { useTranslation } from 'react-i18next';

import { ErrorState, FeatureErrorBoundary } from '@nucleus-commerce/admin-kit/errors';
import { PageContent, PageHeader } from '@nucleus-commerce/admin-kit/layout';
import { Skeleton } from '@nucleus-commerce/ui/components/skeleton';

import { useStoreDetail } from '@/features/stores';
import { ReadOnlyBanner } from '@/shared/store/read-only-banner';
import { useStore } from '@/shared/store/store-context';
import { useStoreEditable } from '@/shared/store/use-store-editable';

import { PinterestSettingsForm } from '../components/pinterest-settings-form';

function Settings() {
  const { t } = useTranslation('social');
  const store = useStore();
  const detail = useStoreDetail(store.id);
  const { editable, reason } = useStoreEditable({ permission: 'settings.write' });

  return (
    <PageContent width="narrow">
      <PageHeader
        title={t('settings.title')}
        description={t('settings.description', { store: store.name })}
      />
      <ReadOnlyBanner reason={reason} />
      {detail.isPending ? (
        <Skeleton className="h-96" />
      ) : detail.error ? (
        <ErrorState error={detail.error} onRetry={() => void detail.refetch()} />
      ) : (
        <PinterestSettingsForm store={detail.data} readOnly={!editable} />
      )}
    </PageContent>
  );
}

/** Pinterest › Settings: how often Nucleus publishes, UTM tagging and the catalogue fetch time. */
export function PinterestSettingsPage() {
  return (
    <FeatureErrorBoundary name="social.settings">
      <Settings />
    </FeatureErrorBoundary>
  );
}
